<template>
  <v-menu :disabled="disabled" v-model="showDatePicker" :close-on-content-click="false" transition="scale-transition">
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        style="position: relative !important; min-width: 160px"
        :disabled="disabled"
        :clearable="!disabled"
        @click:clear="
          currentValue = undefined;
          showDatePicker = false;
          $emit('clear', $event);
        "
        :placeholder="placeholder"
        v-model="currentValue"
        readonly
        v-bind="attrs"
        v-on="on">
        <template v-slot:prepend>
          <v-icon :disabled="disabled" size="20" style="padding-top: 1px !important" @click="showDatePicker = !showDatePicker">
            mdi-calendar</v-icon
          >
        </template>

        <template v-slot:append>
          <v-icon
            :disabled="disabled"
            :style="'transform: rotate(' + (showDatePicker ? '180deg' : '0deg') + ')'"
            @click="showDatePicker = !showDatePicker">
            mdi-menu-down
          </v-icon>
        </template>
      </v-text-field>
    </template>
    <v-date-picker
      no-title
      scrollable
      clearable
      v-model="currentValue"
      :disabled="disabled"
      @click:clear="
        currentValue = undefined;
        showDatePicker = false;
        $emit('clear', $event);
      "
      @change="
        showDatePicker = false;
        $emit('change', $event);
      ">
      <template v-slot:default>
        <v-btn x-small @click="onClickClearDate" space-between padding style="width: 76px; margin-inline: auto">
          <b>Clear</b>
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Date],
      default: undefined,
    },
    placeholder: {
      type: String,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return { currentValue: undefined, showDatePicker: false };
  },
  computed: {},
  watch: {
    value(newValue) {
      this.currentValue = this.formatDateValue(newValue);
    },
  },
  mounted() {
    this.currentValue = this.formatDateValue(this.$props.value);
  },
  beforeDestroy() {},
  methods: {
    formatDateValue(value) {
      if (value instanceof Date) {
        return value.toISOString().slice(0, 10);
      } else if (value) {
        const newDate = new Date(value);
        if (isNaN(newDate.getTime())) {
          console.warn(`Invalid date value: ${value}`);
          return value;
        }
        return newDate.toISOString().slice(0, 10);
      }

      return value;
    },
    onClickClearDate() {
      this.showDatePicker = false;
    },
  },
};
</script>
